export function formatDate(value, pattern = "YYYY-MM-DD HH:mm") {
  if (!value) return "";
  const d = new Date(value);
  const Y = d.getFullYear();
  const M = String(d.getMonth() + 1).padStart(2, "0");
  const D = String(d.getDate()).padStart(2, "0");
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");

  if (pattern === "YYYY-MM-DD") {
    return `${Y}-${M}-${D}`;
  }
  // 預設回傳 YYYY-MM-DD hh:mm
  return `${Y}-${M}-${D} ${h}:${m}`;
}
